export default "__VITE_ASSET__BywPJLiA__"